import { createSlice } from "@reduxjs/toolkit";
import { getTvPrograms, getTvProgramStats, scrapeTvPrograms } from "./thunk";
import { readThunkError } from "../thunkError";

export const initialState = {
  programs: [],
  total: 0,
  stats: null,
  loading: false,
  error: {},
};

const tvProgramSlice = createSlice({
  name: "tvprogram",
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder.addCase(getTvPrograms.pending, (state) => {
      state.loading = true;
    });

    builder.addCase(getTvPrograms.fulfilled, (state, action) => {
      state.programs = (action.payload && action.payload.items) || [];
      state.total = (action.payload && action.payload.total) || 0;
      state.loading = false;
      state.isProgramsSuccess = true;
      state.isProgramsFail = false;
    });

    builder.addCase(getTvPrograms.rejected, (state, action) => {
      state.error = readThunkError(action);
      state.loading = false;
      state.isProgramsSuccess = false;
      state.isProgramsFail = true;
    });

    builder.addCase(getTvProgramStats.fulfilled, (state, action) => {
      state.stats = action.payload;
    });

    builder.addCase(getTvProgramStats.rejected, (state, action) => {
      state.error = readThunkError(action);
    });

    builder.addCase(scrapeTvPrograms.fulfilled, (state) => {
      state.isScrapeStarted = true;
    });

    builder.addCase(scrapeTvPrograms.rejected, (state, action) => {
      state.error = readThunkError(action);
      state.isScrapeStarted = false;
    });
  },
});

export default tvProgramSlice.reducer;
